import type { CuttingLengthContainerDto, CuttingLengthDto } from "../../generated/client/octalog-service";

import { useGetCuttingLengths } from "./useGetCuttingLengths";
import { useIdToNameTranslator } from "./useIdToNameTranslator";

/**
 * Hook to get a function that translates a cutting length ID to its translated name.
 * Fetches cutting lengths using `useGetCuttingLengths`.
 *
 * @returns {(cuttingLengthId: number | undefined) => string | number} Function to translate the ID.
 */
export const useCuttingLengthIdTranslator = (): ((cuttingLengthId: number | undefined) => string | number) => {
  const cuttingLengthsQuery = useGetCuttingLengths();

  return useIdToNameTranslator<CuttingLengthContainerDto, CuttingLengthDto, "cuttingLengthId", "name">(
    cuttingLengthsQuery,
    (data) => data?.cuttingLengths, // Extractor function
    "cuttingLengthId",
    "name",
  );
};
